"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var g_base_1 = require("@antv/g-base");
function isPointInPath(shape, x, y) {
    var ctx = g_base_1.getOffScreenContext();
    shape.createPath(ctx);
    return ctx.isPointInPath(x, y);
}
exports.default = isPointInPath;
//# sourceMappingURL=point-in-path.js.map